import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { FieldOptionReportsData } from './FieldOptionReportsData.types.tsx';

const RESOURCE_TYPE_FIELD_OPTION_PROJECTS_LIMITS = 'FIELD_OPTION_PROJECTS_LIMITS';

export const fieldOptionProjectsLimitsResource: RouteResource<FieldOptionReportsData> =
	createResource<FieldOptionReportsData>({
		type: RESOURCE_TYPE_FIELD_OPTION_PROJECTS_LIMITS,
		getKey: () => 'fieldOptionProjectsLimits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-field-option-projects-limits", jiraSpaEntry: "async-resource-field-option-projects-limits" */ './getFieldOptionData.tsx'
			),
	});
